
























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  @Prop({ type: String, default: "" }) public boxName;
  @Prop({ type: Number, default: 1 }) public cssType; // 1是白底黑字， 2是黑底白字
  public isShow = false;
  public progress = "0%";
  public show() {
    this.progress = "0%";
    this.isShow = true;
  }
  public edit(progress) {
    this.progress = progress;
  }
  public close() {
    this.isShow = false;
    setTimeout(() => {
      this.progress = "0%";
    }, 500);
  }
}
